import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import CreateExpenseWithReceipt from './components/CreateExpenseWithReceipt';
import ExpenseDetailPage from './pages/ExpenseDetailPage';
import ExpenseEditPage from './pages/ExpenseEditPage';
import PendingTasksPage from './pages/PendingTasksPage';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/expenses/create-from-receipt"
              element={
                <ProtectedRoute>
                  <CreateExpenseWithReceipt />
                </ProtectedRoute>
              }
            />
            <Route
              path="/expenses/:id"
              element={
                <ProtectedRoute>
                  <ExpenseDetailPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/expenses/:id/edit"
              element={
                <ProtectedRoute>
                  <ExpenseEditPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/pending-tasks"
              element={
                <ProtectedRoute>
                  <PendingTasksPage />
                </ProtectedRoute>
              }
            />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
